//noScroll
class News {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    /* news　カテゴリー選択  */
    const newsCatSelect = () => {

      const newsCats = document.querySelectorAll(".js-cat");
      const newsArticle = document.querySelectorAll(".news-article")
  
        newsCats.forEach((cat, i) => {
          cat.addEventListener("click", () => {
            const isActiveCat = document.querySelector(".is-catActive")
            const isShowCat = document.querySelector(".is-catShow")
            
            isActiveCat.classList.remove("is-catActive")
            cat.classList.add("is-catActive")
  
  
            isShowCat.classList.remove("is-catShow")
            newsArticle[i].classList.add("is-catShow")
          })
        })
      }
      newsCatSelect();
  
  }
}
